<template lang="html">
  <div v-if="$store.state.show.currentShowDataBound" class="mt-3">
    <b-row v-if="!isCurrentShowTimelineEdited" no-gutters>
      <b-col class="small text-muted mt-1">
        Drag and drop to arrange below.
      </b-col>
      <b-col class="text-right text-muted small mt-1 mr-2">
        Sort images by:
      </b-col>
      <b-col md="3">
        <b-form-select
          v-model="sortOrderSelected"
          :options="sortOptions"
          size="sm"
          @change="changeSortOrderFromSelect"
        />
      </b-col>
    </b-row>
    <SortableGrid
      v-if="!isCurrentShowTimelineEdited"
      :passed-array="show_images"
      :trimmed_image_count="trimmed_image_count"
      :use_all_images="use_all_images"
      @onUpdate="updateImageOrderFromSortable"
    />
    <b-row v-if="imageErrors.length > 0" class="mt-5">
      <b-col md="6">
        <b-alert show variant="secondary" class="mt-5">
          <p class="mb-3">
            <span class="h4">Error Log</span>
            <span class="float-right">
              <b-btn
                size="sm"
                variant="dark"
                @click="$store.dispatch('show/clearErrorImageLog')"
              >
                Clear Log <v-icon name="window-close" />
              </b-btn>
            </span>
          </p>
          <p>
            <v-icon name="exclamation-triangle" /> There was a problem importing
            {{ imageErrors.length }}
            {{ "image" | pluralize(imageErrors.length) }}.
          </p>
          <p class="small">
            Accepted formats:
            {{ $store.state.acceptedImageFormats.split(",").join(", ") }}
          </p>
          <p class="small">Please check the following files and try again.</p>
          <p v-for="image in imageErrors" :key="image.filename" class="small">
            {{ image.name }}
          </p>
        </b-alert>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SortableGrid from "@/components/show/SortableGrid";
import sortBy from "lodash/sortBy";
import map from "lodash/map";
import isEqual from "lodash/isEqual";
export default {
  name: "ShowTimelineLowerGrid",
  components: {
    SortableGrid
  },
  filters: {
    pluralize(word, amount) {
      if (amount > 1) {
        return `${word}s`;
      }
      return word;
    }
  },
  data() {
    return {
      sortOrderSelected: "timeImportedAsc",
      options: [
        { value: "custom", text: "Manual ordering" },
        { value: "timeImportedAsc", text: "Import order - ascending" },
        { value: "timeImportedDesc", text: "Import order - descending" },
        { value: "nameAsc", text: "Filename - ascending" },
        { value: "nameDesc", text: "Filename - descending" },
        { value: "creationDateAsc", text: "Capture time - ascending" },
        {
          value: "creationDateDesc",
          text: "Capture time - descending"
        }
      ],
      lastCustomOrderedFilenames: null
    };
  },
  computed: {
    show() {
      return this.$store.state.show.currentShow;
    },
    show_images() {
      return this.show.data.images;
    },
    trimmed_image_count() {
      return Math.ceil(
        this.show.data.audio.duration / this.show.data.autoTimePerImage
      );
    },
    use_all_images() {
      return this.trimmed_image_count >= this.show_images.length;
    },
    isCurrentShowTimelineEdited() {
      return this.$store.getters["show/isCurrentShowTimelineEdited"];
    },
    imageErrors() {
      return this.$store.state.show.currentShow.staticImagesErrorRemoved || [];
    },
    sortOptions() {
      var options = this.options;
      if (this.$store.state.show.imageMetadataOriginalDateOrder.length === 0) {
        options = map(options, i => {
          if (i.value == "creationDateAsc") {
            i.disabled = true;
          }
          if (i.value == "creationDateDesc") {
            i.disabled = true;
          }
          return i;
        });
      }
      return options;
    }
  },
  mounted() {
    var displaySettings = this.show.data.displaySettings || {};
    if (displaySettings.globalSlideSortOrder) {
      this.sortOrderSelected = displaySettings.globalSlideSortOrder;
    } else {
      // See if the user is using the standard timeImportedAsc.
      var currentOrder = map(this.show_images, "filename");
      var timeImportedAscOrder = map(
        sortBy(this.show_images, "filename"),
        "filename"
      );
      if (isEqual(timeImportedAscOrder, currentOrder)) {
        this.sortOrderSelected = "timeImportedAsc";
      } else {
        this.sortOrderSelected = "custom";
      }
    }
  },
  methods: {
    changeSortOrderFromSelect() {
      // When changing a preset from custom, always offer the ability to undo.
      if (this.sortOrderSelected == "custom") {
        // Do not send images on this change.
        this.updateImageOrder(this.sortOrderSelected);
      } else {
        this.updateImageOrder(this.sortOrderSelected);
      }
    },
    updateImageOrderFromSortable(images) {
      this.sortOrderSelected = "custom";
      this.updateImageOrder(this.sortOrderSelected, images);
    },
    updateImageOrder(sortOrderSelected, images) {
      var update_object = {
        sortOrderSelected: sortOrderSelected,
        images: images
      };
      this.$store.dispatch("show/updateImageOrder", update_object);
    }
  }
};
</script>

<style lang="scss" scoped></style>
